import React from 'react';
import { MdLock, MdLogin, MdPersonAdd } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

interface AuthenticationRequiredProps {
  title?: string;
  message?: string;
  returnTo?: string;
}

export const AuthenticationRequired: React.FC<AuthenticationRequiredProps> = ({
  title = 'Authentication Required',
  message = 'You need to be logged in to purchase a season pass.',
  returnTo = '/passes',
}) => {
  const navigate = useNavigate();

  const handleSignIn = () => {
    navigate('/sign-in', { state: { returnTo } });
  };

  const handleSignUp = () => {
    navigate('/sign-up', { state: { returnTo } });
  };

  return (
    <div className="max-w-full mx-auto mt-4">
      <div className="bg-white rounded-lg shadow-lg p-8 text-center">
        {/* Icon */}
        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <MdLock className="w-8 h-8 text-blue-600" />
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-gray-900 mb-4">{title}</h2>

        {/* Message */}
        <p className="text-gray-600 mb-8 leading-relaxed">{message}</p>

        {/* Action Buttons */}
        <div className="space-y-4">
          <button
            onClick={handleSignIn}
            className="w-full flex items-center justify-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
          >
            <MdLogin className="w-5 h-5 mr-2" />
            Sign In
          </button>

          <button
            onClick={handleSignUp}
            className="w-full flex items-center justify-center px-6 py-3 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
          >
            <MdPersonAdd className="w-5 h-5 mr-2" />
            Create Account
          </button>
        </div>

        {/* Additional Info */}
        <div className="mt-8 p-4 bg-blue-50 rounded-lg">
          <p className="text-sm text-blue-800">
            <strong>Why do I need an account?</strong>
            <br />
            Season passes are linked to your account for easy access and
            management. You'll be able to view your pass details and usage
            history anytime.
          </p>
        </div>
      </div>
    </div>
  );
};
